import { useEffect, useRef } from "react";
import "./ripple.scss";

interface RippleProps {
  x: number;
  y: number;
  size: number;
  onComplete?: () => void;
}

export const Ripple: React.FC<RippleProps> = ({ x, y, size, onComplete }) => {
  const rippleRef = useRef<HTMLSpanElement>(null);

  useEffect(() => {
    const ripple = rippleRef.current;
    if (!ripple) return;

    const handleAnimationEnd = () => {
      onComplete?.();
    };

    ripple.addEventListener("animationend", handleAnimationEnd);
    return () => {
      ripple.removeEventListener("animationend", handleAnimationEnd);
    };
  }, [onComplete]);

  return (
    <span
      ref={rippleRef}
      className="ripple"
      style={{
        width: size,
        height: size,
        left: x - size / 2,
        top: y - size / 2,
      }}
    />
  );
};
